import { Button, Col, Container, Paragraph, Row, Typography } from 'darrius';

import { MdAttachMoney, MdWork, MdPeopleAlt } from 'react-icons/md';

import styles from './Hero.module.scss';

export const Hero = () => {
  return (
    <>
      <img
        className={styles['signup-mgm__hero__banner']}
        src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/banner-mgm-discounts.png`}
        alt="Imagem de moedas amarelas representando ganhos por bonus"
      />
      <Container className="space-bottom">
        <Row className={`${styles['signup-mgm__hero__notice']} space-bottom`}>
          <Col className="col-md-6 col-sm-12 center">
            <Typography.Subtitle
              size="l"
              className="no-margins center-sm start-md"
            >
              Aproveite já esse presente! Baixe o aplicativo, cadastre-se e
              comece a conseguir clientes
            </Typography.Subtitle>
          </Col>

          <Col className="col-md-3 col-sm-12 center">
            <Button.Link
              size="small"
              href="https://www.getninjas.com.br/instale"
              variation="inverse"
            >
              Baixar o aplicativo
            </Button.Link>
          </Col>

          <Col
            className={`${styles['signup-mgm__hero__img']} col-md-3 col-sm-12 center-sm center`}
          >
            <img
              src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/playstore.png`}
              width="120px"
              alt="Imagem da PlayStore"
            />
            <img
              src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/appstore.png`}
              width="115px"
              alt="Imagem da AppStore"
            />
          </Col>
        </Row>
      </Container>
      <Container className={`${styles['signup-mgm__advantage']} space-bottom`}>
        <Row className="center space-bottom">
          <Col className="col-sm-12 col-md-4 space-bottom">
            <MdPeopleAlt size={24} />
            <Typography.Subtitle size="l">Mais Clientes</Typography.Subtitle>
            <Typography.Text className={styles.text}>
              São mais de 300 mil clientes solicitando serviços todos os dias
              através do app.
            </Typography.Text>
          </Col>
          <Col className="col-sm-12 col-md-4 space-bottom">
            <MdWork size={24} />
            <Typography.Subtitle size="l">
              Variedade de serviços
            </Typography.Subtitle>
            <Typography.Text className={styles.text}>
              São mais de 200 categorias diferentes para você trabalhar,
              encontre já a sua.
            </Typography.Text>
          </Col>
          <Col className="col-sm-12 col-md-4 space-bottom">
            <MdAttachMoney size={24} />
            <Typography.Subtitle size="l">Sem Comissão</Typography.Subtitle>
            <Typography.Text className={styles.text}>
              No GetNinjas o valor do serviço é inteiro seu! Trabalhe sem
              comissão.
            </Typography.Text>
          </Col>
        </Row>
      </Container>
    </>
  );
};
